import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ChatMessage } from 'APP/store/Messages/Message/ChatMessage/ChatMessage';

import { useSenderNamePresenter } from './SenderName.presenter';
import { SenderNameForAdmins } from './SenderNameForAdmins/SenderNameForAdmins';
import { SenderNameForUser } from './SenderNameForUser/SenderNameForUser';

interface ISenderNameProps {
  message: ChatMessage;
  className?: string;
}

export const SenderName: FC<ISenderNameProps> = observer(({ message, className }) => {
  const presenter = useSenderNamePresenter(message);

  if (!presenter.isShow) {
    return null;
  }

  if (presenter.withMeInAdmins && !presenter.isSavedMessages) {
    return (
      <SenderNameForAdmins
        message={message}
        className={className}
      />
    );
  }

  return (
    <SenderNameForUser
      message={message}
      className={className}
    />
  );
});
